import * as React from 'react'
import { Flex } from '@radix-ui/themes'
import { yenKanji } from '@/lib/price'
import { styles } from './styles.css'

type Props = {
  inBulkOrderbleId: string | null
}

function rows({ inBulkOrderbleId }): Record<string, string>[] {
  if (inBulkOrderbleId) {
    return [
      { label: '季節のおまかせブーケ（1配送分）', price: yenKanji(2700) },
      { label: 'mazzo', price: yenKanji(1800) },
      { label: 'お花の栄養剤（5回分）', price: yenKanji(0) },
      { label: '配送料', price: yenKanji(0) },
      { label: '消費税', price: yenKanji(450) },
    ]
  } else {
    return [
      { label: '季節のおまかせブーケ（1配送分）', price: yenKanji(2700) },
      { label: 'お花の栄養剤（5回分）', price: yenKanji(0) },
      { label: '配送料', price: yenKanji(0) },
      { label: '消費税', price: yenKanji(270) },
    ]
  }
}

function total({ inBulkOrderbleId }): string {
  if (inBulkOrderbleId) {
    return yenKanji(4500 + 450)
  } else {
    return yenKanji(2700 + 270)
  }
}

export const PriceTable: React.FC<Props> = ({ inBulkOrderbleId }) => {
  return (
    <Flex direction="column" role="table" gap="16px" width="100%">
      {rows({ inBulkOrderbleId }).map((row) => (
        <Flex direction="row" justify="between" align="center" key={row.label}>
          <span className={styles.cell}>{row.label}</span>
          <span className={styles.cell}>{row.price}</span>
        </Flex>
      ))}
      <hr className={styles.divider} />
      <Flex direction="row" justify="between" align="center">
        <span className={styles.totalCell}>合計</span>
        <span className={styles.totalCell}>{total({ inBulkOrderbleId })}</span>
      </Flex>
    </Flex>
  )
}
